<script>
export default {
  name: 'Login',
  data() {
    return {
      isLoading: true,
      error: null,
    };
  },
  async mounted() {
    try {
      // Check if we're returning from Okta (callback)
      if (this.$route.path === '/login/callback') {
        await this.handleCallback();
      } else {
        // Redirect to Okta for authentication
        await this.redirectToLogin();
      }
    } catch (err) {
      console.error('Login error:', err);
      this.error = err.message || 'An error occurred during login';
      this.isLoading = false;
    }
  },
  methods: {
    async redirectToLogin() {
      // Use signInWithRedirect to redirect to Okta's hosted login page
      await this.$auth.signInWithRedirect({
        originalUri: this.$route.query.redirect || '/domains',
      });
    },
    async handleCallback() {
      try {
        // Handle the callback from Okta
        await this.$auth.handleLoginRedirect();

        // Get the original URI or default to /domains
        const originalUri = this.$auth.getOriginalUri() || '/domains';

        // Navigate to the original URI
        this.$router.push(originalUri);
      } catch (err) {
        console.error('Callback error:', err);
        this.error = 'Failed to complete login. Please try again.';
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <div class="login">
    <div class="login-container">
      <div v-if="isLoading" class="loading">
        <div class="spinner"></div>
        <p>Redirecting to login...</p>
      </div>
      <div v-if="error" class="error">
        <p>{{ error }}</p>
        <button @click="redirectToLogin">Try Again</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f5f5;
}

.login-container {
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 300px;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error {
  color: #d32f2f;
}

.error button {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.error button:hover {
  background: #2980b9;
}
</style>



// WEBPACK FOOTER //
// client/routes/login/index.vue